import PropTypes from 'prop-types'
import { OperationStatus, OperationStatusInOrder } from 'features/Codes'
import Tooltip from 'components/tooltip/Tooltip'
import { Fragment, memo } from 'react'
import Wrap from 'components/Wrap'

const OperationStatusDisplay = memo(({ operationStatus, container }) => {
  const operationStatusInOrder = OperationStatusInOrder.filter(status =>
    operationStatus.includes(status)
  )
  const [representativeStatus] = operationStatusInOrder
  const shouldShowReason =
    representativeStatus !== OperationStatus.ON &&
    representativeStatus !== OperationStatus.DELETED

  return (
    <Wrap
      on={shouldShowReason}
      wrapper={({ children }) => (
        <Tooltip
          position="bottom alignLeft"
          container={container}
          display="block"
          offsetX={10}
          offsetY={10}
          content={operationStatusInOrder.map(({ name, title, msg }) => (
            <Fragment key={name}>
              <strong className="tit_tooltip">운영 불가({title})</strong>
              <p className="txt_tooltip2">{msg}</p>
            </Fragment>
          ))}>
          {children}
        </Tooltip>
      )}>
      <p className="ad_state ico_state">
        {representativeStatus === OperationStatus.ON ? (
          <span className="ico_on">on</span>
        ) : (
          <span className="ico_off">off</span>
        )}
        <Wrap
          on={shouldShowReason}
          wrapper={({ children }) => <>운영 불가({children})</>}>
          {representativeStatus.title}
        </Wrap>
        {operationStatusInOrder.length > 1 && (
          <>({operationStatusInOrder.length})</>
        )}
      </p>
    </Wrap>
  )
})
export default OperationStatusDisplay

OperationStatusDisplay.displayName = 'OperationStatusDisplay'
OperationStatusDisplay.propTypes = {
  operationStatus: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  container: PropTypes.node,
}
